import _ErrorPage from './_ErrorPage';

const NotFoundErrorPage: React.FC = () => {
  return (
    <_ErrorPage
      title="페이지를 찾을 수 없습니다."
      description="주소가 잘못 입력되었거나 변경 또는 삭제되어 요청하신 페이지를 찾을 수 없습니다."
      buttonTo="/task"
      buttonLabel="홈으로"
    />
  );
};

export default NotFoundErrorPage;
